import { InjectionToken } from '@angular/core';

/**
 * SSR-only hook returning the markup of a local SVG asset read straight from
 * the server filesystem, or `null` to fall back to the HTTP path.
 *
 * On the server the SvgService must not fetch local `/assets/*.svg` over HTTP:
 * that request targets the app's own public URL and, behind the Cloud Run load
 * balancer, deadlocks against the busy SSR worker (~10s timeout) and blocks the
 * page from being serialized. Reading the file directly avoids any round-trip.
 *
 * The token is provided only on the server (see `app.config.server.ts`); in the
 * browser it is absent, so the SvgService keeps its regular HTTP behavior.
 */
export type SvgAssetReader = (src: string) => string | null;

export const SVG_ASSET_READER = new InjectionToken<SvgAssetReader>('SVG_ASSET_READER');
